import Validation from '~/lib/validation';
import { isEmail }  from 'validator';

export const passwordRegExp = /^(?=.*[A-Za-z])(?=.*[0-9$@$!%*#?&-_])[A-Za-z\d$@$!%*#?&-_]{8,}$/;

export const request = {
  email: [
    Validation.required,
    Validation.custom({
      type: "email",
      fn: ( x: string) => isEmail(x)
    })
  ]
};

export const process = {
  nextPassword: [
    Validation.required,
    Validation.pattern(passwordRegExp)
  ]
};
